import { getHeaders } from '../headers';

const cleanFilterValue = (value) => {
  if (value == null) {
    return null;
  }

  const trimmed = `${value}`.trim();
  if (!trimmed || trimmed.toLowerCase() === 'all') {
    return null;
  }
  return trimmed;
};

const cleanGroupByValue = (value) => {
  const normalized = `${value || ''}`.trim().toLowerCase();
  if (normalized === 'school' || normalized === 'role') {
    return normalized;
  }
  return 'none';
};

const cleanFilterArray = (value) => {
  const values = Array.isArray(value) ? value : [value];
  const cleaned = values.map((item) => cleanFilterValue(item)).filter(Boolean);
  return [...new Set(cleaned)];
};

export const fetchPulseAnalysisV2Data = async (baseUrl, filters = {}) => {
  const queryParams = new URLSearchParams();
  const surveyId = cleanFilterValue(filters.survey_id);
  const schoolValues = cleanFilterArray(filters.school);
  const roleValues = cleanFilterArray(filters.role);
  const groupBy = cleanGroupByValue(filters.group_by);

  if (surveyId) {
    queryParams.append('survey_id', surveyId);
  }
  schoolValues.forEach((school) => queryParams.append('school[]', school));
  roleValues.forEach((role) => queryParams.append('role[]', role));
  if (groupBy) {
    queryParams.append('group_by', groupBy);
  }

  const query = queryParams.toString() ? `?${queryParams.toString()}` : '';
  const response = await fetch(`${baseUrl}${query}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      ...getHeaders(),
    },
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(errorText || response.statusText);
  }

  return response.json();
};

export const exportPulseOpenTextCsv = async (exportUrl, filters = {}) => {
  const queryParams = new URLSearchParams();
  const surveyId = cleanFilterValue(filters.survey_id);
  const schoolValues = cleanFilterArray(filters.school);
  const roleValues = cleanFilterArray(filters.role);

  if (surveyId) queryParams.append('survey_id', surveyId);
  schoolValues.forEach((school) => queryParams.append('school[]', school));
  roleValues.forEach((role) => queryParams.append('role[]', role));

  const query = queryParams.toString() ? `?${queryParams.toString()}` : '';
  const response = await fetch(`${exportUrl}${query}`, {
    method: 'GET',
    headers: getHeaders(),
  });

  if (!response.ok) {
    throw new Error('Export failed');
  }

  return response.blob();
};
